import { render, staticRenderFns } from "./FieldCompare.vue?vue&type=template&id=49235160&scoped=true&"
import script from "./FieldCompare.vue?vue&type=script&lang=js&"
export * from "./FieldCompare.vue?vue&type=script&lang=js&"
import style0 from "./FieldCompare.vue?vue&type=style&index=0&id=49235160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49235160",
  null
  
)

export default component.exports